import React from "react";

function Progress(props) {
  const progress = props.data;
  return (
    // <div className="progress-course d-inline">
    <div className=" progress-course">
      <div className="row align-items-center pt-2 pb-2  bg-dark ">
        <div
          className="d-inline d-lg-inline"
          style={{
            width: "300px"
          }}
        >
          <div className="progress">
            <div
              className="progress-bar progress-bar-striped bg-success"
              role="progressbar"
              style={{ width: progress }}
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {progress}
            </div>
          </div>
        </div>

        <div className="d-inline d-lg-inline  text-light">
          <span
            style={{
              fontSize: "1.2em",
              paddingLeft: "1em"
            }}
          >
            <i className="fas fa-trophy" />
          </span>
        </div>
      </div>
    </div>

    // </div>
  );
}

export default Progress;
